// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1219":"12ebca7341bec893","8961":"d4fc3620479c2764"}[chunkId] + ".css";
};